import {Project} from "../api/Project";

export const jacoturaProject: Project = {
    id: 8,
    title: 'Jacotura',
    description: 'Gradle plugin to convert JaCoCo coverage reports to Cobertura coverage reports',
    link: 'https://github.com/chirag-ji/Jacotura',
    image: 'https://github.githubassets.com/pinned-octocat.svg',
    startDate: 'January 2022',
    completeDate: 'January 2022',
    hidden: false,
    technologies: {
        frontend: undefined,
        backend: [
            'Java Core',
            'Gradle API',
            'SAX (Simple API for XML)',
        ]
    }
};
